import { render, staticRenderFns } from "./CustomerWizard.vue?vue&type=template&id=51c7f64e&"
import script from "./CustomerWizard.vue?vue&type=script&lang=js&"
export * from "./CustomerWizard.vue?vue&type=script&lang=js&"
import style0 from "./CustomerWizard.vue?vue&type=style&index=0&id=51c7f64e&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports